import { forwardRef, memo } from 'react';
import { SvgIcon } from '@material-ui/core';

export const FifthGrader = memo(
  forwardRef((props, ref) => {
    return (
      <SvgIcon
        {...props}
        ref={ref}
        viewBox="0 0 248 143"
        data-fill-none
      >
        <g clipPath="url(#clip0_1503_14947)">
          <rect
            width="248"
            height="143"
            rx="8"
            fill="#F4F4F4"
          />
          <rect
            x="73.75"
            y="33.75"
            width="61.5"
            height="83.3571"
            rx="4.39286"
            fill="white"
            stroke="#191919"
            strokeWidth="1.5"
          />
          <path
            d="M130.938 34.2857L74.2857 112.457C74.2857 112.457 74.6836 114.595 75.3919 115.366C76.1002 116.138 77.0608 116.571 78.0625 116.571H130.938C131.939 116.571 132.9 116.138 133.608 115.366C134.316 114.595 134.714 113.548 134.714 112.457V38.4C134.714 37.3088 134.316 36.2623 133.608 35.4908C132.9 34.7192 130.938 34.2857 130.938 34.2857Z"
            fill="#E3E3E3"
          />
          <path
            d="M87.1429 52.2856H112.759"
            stroke="#191919"
            strokeWidth="1.92857"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M87.1429 59.9999H120.078"
            stroke="#191919"
            strokeWidth="1.92857"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M87.1429 67.7142H112.759"
            stroke="#191919"
            strokeWidth="1.92857"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M87.1429 75.4285H120.078"
            stroke="#191919"
            strokeWidth="1.92857"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M87.1429 83.1428H120.078"
            stroke="#191919"
            strokeWidth="1.92857"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M87.1429 90.8571H120.078"
            stroke="#191919"
            strokeWidth="1.92857"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M87.1429 98.5714H112.759"
            stroke="#191919"
            strokeWidth="1.92857"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <rect
            x="73.75"
            y="33.75"
            width="61.5"
            height="83.3571"
            rx="4.39286"
            stroke="#191919"
            strokeWidth="1.5"
          />
          <path
            d="M156.404 87.6141L153.999 90.0195L145.981 82.0016L148.386 79.5962C149.455 78.5613 150.888 77.9881 152.376 78.0002C153.864 78.0123 155.287 78.6087 156.339 79.6608C157.391 80.7129 157.988 82.1364 158 83.6242C158.012 85.1121 157.439 86.5451 156.404 87.6141Z"
            fill="#FF808C"
          />
          <path
            d="M137.225 106.793L126 110L129.207 98.7749L137.225 106.793Z"
            fill="#FFBC44"
          />
          <path
            d="M145.981 82.0048L129.207 98.7783L137.225 106.796L153.998 90.0227L145.981 82.0048Z"
            fill="#FFEF5E"
          />
          <path
            d="M156.404 87.6141L153.999 90.0195L145.981 82.0016L148.386 79.5962C149.455 78.5613 150.888 77.9881 152.376 78.0002C153.864 78.0123 155.287 78.6087 156.339 79.6608C157.391 80.7129 157.988 82.1364 158 83.6242C158.012 85.1121 157.439 86.5451 156.404 87.6141Z"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M137.225 106.793L126 110L129.207 98.7749L137.225 106.793Z"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M145.981 82.0048L129.207 98.7783L137.225 106.796L153.998 90.0227L145.981 82.0048Z"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M143.219 40.9375H131.594C130.566 40.9375 129.58 41.3458 128.854 42.0725C128.127 42.7992 127.719 43.7848 127.719 44.8125V56.4375C127.719 57.4652 128.127 58.4508 128.854 59.1775C129.58 59.9042 130.566 60.3125 131.594 60.3125H143.219C144.246 60.3125 145.232 59.9042 145.959 59.1775C146.685 58.4508 147.094 57.4652 147.094 56.4375V44.8125C147.094 43.7848 146.685 42.7992 145.959 42.0725C145.232 41.3458 144.246 40.9375 143.219 40.9375Z"
            fill="#66E1FF"
          />
          <path
            d="M143.219 40.9375H131.594C130.566 40.9375 129.58 41.3458 128.854 42.0725C128.127 42.7992 127.719 43.7848 127.719 44.8125V50.625C127.719 49.5973 128.127 48.6117 128.854 47.885C129.58 47.1583 130.566 46.75 131.594 46.75H143.219C144.246 46.75 145.232 47.1583 145.959 47.885C146.685 48.6117 147.094 49.5973 147.094 50.625V44.8125C147.094 43.7848 146.685 42.7992 145.959 42.0725C145.232 41.3458 144.246 40.9375 143.219 40.9375Z"
            fill="#C2F3FF"
          />
          <path
            d="M168.406 40.9375H156.781C155.754 40.9375 154.768 41.3458 154.041 42.0725C153.315 42.7992 152.906 43.7848 152.906 44.8125V56.4375C152.906 57.4652 153.315 58.4508 154.041 59.1775C154.768 59.9042 155.754 60.3125 156.781 60.3125H168.406C169.434 60.3125 170.42 59.9042 171.146 59.1775C171.873 58.4508 172.281 57.4652 172.281 56.4375V44.8125C172.281 43.7848 171.873 42.7992 171.146 42.0725C170.42 41.3458 169.434 40.9375 168.406 40.9375Z"
            fill="#FF808C"
          />
          <path
            d="M168.406 40.9375H156.781C155.754 40.9375 154.768 41.3458 154.041 42.0725C153.315 42.7992 152.906 43.7848 152.906 44.8125V50.625C152.906 49.5973 153.315 48.6117 154.041 47.885C154.768 47.1583 155.754 46.75 156.781 46.75H168.406C169.434 46.75 170.42 47.1583 171.146 47.885C171.873 48.6117 172.281 49.5973 172.281 50.625V44.8125C172.281 43.7848 171.873 42.7992 171.146 42.0725C170.42 41.3458 169.434 40.9375 168.406 40.9375Z"
            fill="#FFBFC5"
          />
          <path
            d="M155.812 17.6875H144.188C143.16 17.6875 142.174 18.0958 141.447 18.8225C140.721 19.5492 140.312 20.5348 140.312 21.5625V33.1875C140.312 34.2152 140.721 35.2008 141.447 35.9275C142.174 36.6542 143.16 37.0625 144.188 37.0625H155.812C156.84 37.0625 157.826 36.6542 158.553 35.9275C159.279 35.2008 159.688 34.2152 159.688 33.1875V21.5625C159.688 20.5348 159.279 19.5492 158.553 18.8225C157.826 18.0958 156.84 17.6875 155.812 17.6875Z"
            fill="#78EB7B"
          />
          <path
            d="M155.812 17.6875H144.188C143.16 17.6875 142.174 18.0958 141.447 18.8225C140.721 19.5492 140.312 20.5348 140.312 21.5625V27.375C140.312 26.3473 140.721 25.3617 141.447 24.635C142.174 23.9083 143.16 23.5 144.188 23.5H155.812C156.84 23.5 157.826 23.9083 158.553 24.635C159.279 25.3617 159.688 26.3473 159.688 27.375V21.5625C159.688 20.5348 159.279 19.5492 158.553 18.8225C157.826 18.0958 156.84 17.6875 155.812 17.6875Z"
            fill="#C9F7CA"
          />
          <path
            d="M143.219 40.9375H131.594C130.566 40.9375 129.58 41.3458 128.854 42.0725C128.127 42.7992 127.719 43.7848 127.719 44.8125V56.4375C127.719 57.4652 128.127 58.4508 128.854 59.1775C129.58 59.9042 130.566 60.3125 131.594 60.3125H143.219C144.246 60.3125 145.232 59.9042 145.959 59.1775C146.685 58.4508 147.094 57.4652 147.094 56.4375V44.8125C147.094 43.7848 146.685 42.7992 145.959 42.0725C145.232 41.3458 144.246 40.9375 143.219 40.9375Z"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M168.406 40.9375H156.781C155.754 40.9375 154.768 41.3458 154.041 42.0725C153.315 42.7992 152.906 43.7848 152.906 44.8125V56.4375C152.906 57.4652 153.315 58.4508 154.041 59.1775C154.768 59.9042 155.754 60.3125 156.781 60.3125H168.406C169.434 60.3125 170.42 59.9042 171.146 59.1775C171.873 58.4508 172.281 57.4652 172.281 56.4375V44.8125C172.281 43.7848 171.873 42.7992 171.146 42.0725C170.42 41.3458 169.434 40.9375 168.406 40.9375Z"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M155.812 17.6875H144.188C143.16 17.6875 142.174 18.0958 141.447 18.8225C140.721 19.5492 140.312 20.5348 140.312 21.5625V33.1875C140.312 34.2152 140.721 35.2008 141.447 35.9275C142.174 36.6542 143.16 37.0625 144.188 37.0625H155.812C156.84 37.0625 157.826 36.6542 158.553 35.9275C159.279 35.2008 159.688 34.2152 159.688 33.1875V21.5625C159.688 20.5348 159.279 19.5492 158.553 18.8225C157.826 18.0958 156.84 17.6875 155.812 17.6875Z"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M147.094 33.1875V24.4688C147.094 24.0871 147.169 23.7092 147.315 23.3566C147.461 23.004 147.675 22.6836 147.945 22.4137C148.215 22.1439 148.535 21.9298 148.888 21.7837C149.24 21.6377 149.618 21.5625 150 21.5625C150.382 21.5625 150.76 21.6377 151.112 21.7837C151.465 21.9298 151.785 22.1439 152.055 22.4137C152.325 22.6836 152.539 23.004 152.685 23.3566C152.831 23.7092 152.906 24.0871 152.906 24.4688V33.1875"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M147.094 27.375H152.906"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M140.312 47.7188C140.312 48.4895 140.006 49.2288 139.461 49.7738C138.916 50.3188 138.177 50.625 137.406 50.625H134.5V44.8125H137.406C138.177 44.8125 138.916 45.1187 139.461 45.6637C140.006 46.2087 140.312 46.948 140.312 47.7188Z"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M140.312 53.5312C140.312 54.302 140.006 55.0413 139.461 55.5863C138.916 56.1313 138.177 56.4375 137.406 56.4375H134.5V50.625H137.406C138.177 50.625 138.916 50.9312 139.461 51.4762C140.006 52.0212 140.312 52.7605 140.312 53.5312Z"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M164.531 56.4375C162.99 56.4375 161.511 55.8251 160.421 54.7351C159.331 53.645 158.719 52.1666 158.719 50.625C158.719 49.0834 159.331 47.605 160.421 46.5149C161.511 45.4249 162.99 44.8125 164.531 44.8125"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_1503_14947">
            <rect
              width="248"
              height="143"
              rx="8"
              fill="white"
            />
          </clipPath>
        </defs>
      </SvgIcon>
    );
  })
);
